import axios from "axios";


/*let siteUrl = 'http://polifarb-color-back';*/
let siteUrl = 'http://api.color.polifarb.ua';

const URL_USER = siteUrl+'/api/account';
const URL_CHANGE_USER = siteUrl+'/api/account/update-user';
const URL_CHANGE_PASSWORD = siteUrl+'/api/account/update-password';
const URL_CHANGE_PRICE_COLORANT = siteUrl+'/api/account/update-price-colorant/';
const URL_CHANGE_PRICE_PRODUCT = siteUrl+'/api/account/update-price-product/';

// initial state
const state = () => ({
    user: null,
    status: '',

})

// getters
const getters = {
    getStatus: state => state.status,
    getUser: state => state.user,
}

// actions
const actions = {
    user({commit}){
        return new Promise((resolve, reject) => {
            commit('send_request')
            axios({url: URL_USER, method: 'GET' })
                .then(resp => {
                    commit('send_user', resp.data)
                })
                .catch(err => {
                    commit('send_error')
                    reject(err.response.data)
                })
        })
    },
    changeUser({commit}, user) {
        return new Promise((resolve, reject) => {
            commit('send_request')
            axios({url: URL_CHANGE_USER, data: user, method: 'POST' })
                .then(resp => {
                    commit(' ', resp.data)
                    resolve(resp.data.message)
                })
                .catch(err => {
                    commit('send_error')
                    reject(err.response.data)
                })
        })
    },
    changePassword({commit}, user) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            axios({url: URL_CHANGE_PASSWORD, data: user, method: 'POST' })
                .then(resp => {
                    commit('auth_user', resp.data)
                    resolve(resp.data.message)
                })
                .catch(err => {
                    commit('send_error')
                    reject(err.response.data)
                })
        })
    },
    changePriceColorant({commit}, data) {
        return new Promise((resolve, reject) => {
            commit('send_request')
            axios({url: URL_CHANGE_PRICE_COLORANT, data: data, method: 'POST' })
                .then(resp => {
                    commit('send_colorants', resp)
                    resolve()
                })
                .catch(err => {
                    commit('send_error')
                    reject(err.response.data)
                })
        })
    },
    changePriceProduct({commit}, data) {
        return new Promise((resolve, reject) => {
            commit('send_request')
            axios({url: URL_CHANGE_PRICE_PRODUCT, data: data, method: 'POST' })
                .then(resp => {
                    commit('send_products', resp.data)
                    resolve()
                })
                .catch(err => {
                    commit('send_error')
                    reject(err.response.data)
                })
        })
    },
}

// mutations
const mutations = {
    send_request(state){
        state.status = 'loading'
    },
    send_error(state){
        state.status = 'error'
    },
    send_user(state, payload){
        state.user = payload.data
    },
    send_colorants(state, payload){
        state.user.clorants = payload.data
    },
    send_products(state, payload){
        state.user.product = payload.data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}